/* tslint:disable */
/* eslint-disable */
/**
 * Bias Proof License API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ImplicitBiasInterpretation,
    ImplicitBiasInterpretationFromJSON,
    ImplicitBiasInterpretationFromJSONTyped,
    ImplicitBiasInterpretationToJSON,
    ImplicitBiasInterpretationDirection,
    ImplicitBiasInterpretationDirectionFromJSON,
    ImplicitBiasInterpretationDirectionFromJSONTyped,
    ImplicitBiasInterpretationDirectionToJSON,
} from './';

/**
 * 
 * @export
 * @interface TestSummaryItemDTO
 */
export interface TestSummaryItemDTO {
    /**
     * 
     * @type {number}
     * @memberof TestSummaryItemDTO
     */
    count: number;
    /**
     * 
     * @type {ImplicitBiasInterpretation}
     * @memberof TestSummaryItemDTO
     */
    interpretation: ImplicitBiasInterpretation;
    /**
     * 
     * @type {ImplicitBiasInterpretationDirection}
     * @memberof TestSummaryItemDTO
     */
    direction: ImplicitBiasInterpretationDirection;
    /**
     * 
     * @type {number}
     * @memberof TestSummaryItemDTO
     */
    averageScore: number;
}

export function TestSummaryItemDTOFromJSON(json: any): TestSummaryItemDTO {
    return TestSummaryItemDTOFromJSONTyped(json, false);
}

export function TestSummaryItemDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestSummaryItemDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'interpretation': ImplicitBiasInterpretationFromJSON(json['interpretation']),
        'direction': ImplicitBiasInterpretationDirectionFromJSON(json['direction']),
        'averageScore': json['averageScore'],
    };
}

export function TestSummaryItemDTOToJSON(value?: TestSummaryItemDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'interpretation': ImplicitBiasInterpretationToJSON(value.interpretation),
        'direction': ImplicitBiasInterpretationDirectionToJSON(value.direction),
        'averageScore': value.averageScore,
    };
}


